import React from 'react'
import Button from 'react-bootstrap/Button';
import { t } from 'i18next';



export default function PostFeedbackButton(props) {

  const handleButtonClick = () => {
    props.onClick();
  }
  
  return (
    <Button variant="success" size='sm'
     className='fw-medium m-2 mb-0'
     onClick={()=>handleButtonClick()}
    ><div className='d-flex align-items-center'><i class="ti ti-plus fs-5 me-1"></i> {t('general.label.dashboard.button.addFeedback')}</div></Button>
  )
}
